<template>
<transition>
  <div class="dialog" v-if="show">
    <div class="content" :style="{height: this.height + 'px', width: this.width + 'px'}">
      <img src="../assets/img/icon_close.png" class="close" @click="closeAction">
      <img src="../assets/img/img_text_2.png" alt="" class="text">
      <el-button type="primary" round class="done" @click="doneAction">{{ $t("B2B.vButton") }}</el-button>
    </div>
  </div>
</transition>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 706
    },
    height: {
      type: Number,
      default: 430
    }
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    closeAction () {
      this.show = false
    },
    doneAction () {
      this.show = false
      this.$emit('done')
    }
  }
}
</script>

<style lang="scss" scoped>
.v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-active, .v-leave-active {
  transition: opacity 0.5s;
}
.dialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  .content {
    background-color: white;
    border-radius: 20px;
    background-image: url('../assets/img/img_popup_1.png');
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: 0 0;
    position: relative;

    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor:pointer;
    }

    .text {
      display: block;
      margin: 176px auto 0;
    }

    .done {
      margin-top: 60px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
}
</style>
